import {
  setConfigData,
  setReUploadSummaryData,
  setSummaryData
} from '@cp/src/reducers/allocationSlice';
import axiosInstance, { ApiKeys, getApiUrl, logError } from '@cp/src/utils/ApiHelper';
import { toast } from '@navi/web-ui/lib/primitives/Toast';
import { Dispatch } from '@reduxjs/toolkit';

export const getAllocationStatus = (collectionType: string) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.GET_ALLOCATIONS_CONFIGS);
  axiosInstance
    .get(url, { params: { collectionType }, headers: { donotHandleError: true } })
    .then(res => {
      dispatch(setConfigData(res.data));
    });
};

export const triggerAllocation =
  (payload: any, successCallBack: () => void) => (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.TRIGGER_ALLOCATION);

    axiosInstance
      .post(url, payload, { headers: { donotHandleError: true } })
      .then(res => {
        toast.success('Allocation triggered successfully');
        successCallBack();
      })
      .catch(err => {
        logError('Error triggering allocation', err);
      });
  };

export const getAllocationSummary =
  (configName: string, collectionType: string) => (dispatch: Dispatch) => {
    const url = getApiUrl(ApiKeys.GET_ALLOCATION_SUMMARY);
    axiosInstance
      .get(url, { params: { configName, collectionType }, headers: { donotHandleError: true } })
      .then(res => {
        dispatch(setSummaryData(res.data));
      })
      .catch(err => {
        dispatch(setSummaryData({}));
        logError('Error fetching allocation summary', err);
      });
  };

export const reUploadInitiate = (successCallBack: () => void) => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.RE_UPLOAD_INITIATE);
  axiosInstance
    .post(url, {}, { headers: { donotHandleError: true } })
    .then(res => {
      successCallBack();
      toast.success('Re-upload initiated successfully');
    })
    .catch(err => {
      logError('Error initiating re-upload', err);
    });
};

export const getReUploadSummary = () => (dispatch: Dispatch) => {
  const url = getApiUrl(ApiKeys.RE_UPLOAD_SUMMARY);
  axiosInstance
    .get(url, { headers: { donotHandleError: true } })
    .then(res => {
      dispatch(setReUploadSummaryData(res.data));
    })
    .catch(err => {
      dispatch(setReUploadSummaryData({}));
      logError('Error fetching re-upload summary', err);
    });
};
